import { Snapshot } from "@custom-types/base-types";
import { GridColDef } from "@mui/x-data-grid-pro";

/** The column definition for the snapshots table with the field property typed */
export type SnapshotsTableGridColDef = Omit<
  GridColDef<{ entity: Snapshot }>,
  "field"
> & {
  field: SnapshotsTableColumnField;
};

/** All available column fields for the snapshots table */
export const SNAPSHOTS_TABLE_COLUMNS = [
  "name",
  "accessLevel",
  "created",
  "options",
] as const;

/** The column fields that can be used in the snapshots table */
export type SnapshotsTableColumnField =
  (typeof SNAPSHOTS_TABLE_COLUMNS)[number];

/** Sortable column fields for the snapshots table */
export const SNAPSHOTS_SORT_BY = [
  "name_ascending",
  "name_descending",
  "created_ascending",
  "created_descending",
  "accessLevel_ascending",
  "accessLevel_descending",
] as const;

/** All possible snapshots sort by values */
export type SnapshotsSortBy = (typeof SNAPSHOTS_SORT_BY)[number];

/** Available snapshots sort fields - derived from SNAPSHOTS_SORTABLE_FIELDS */
export type SnapshotsSortField = Exclude<SnapshotsTableColumnField, "options">;
